module.exports = __webpack_public_path__ + "static/media/img1.447ed7c4.png";